// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function KitchenSinkElement(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'KitchenSinkElement',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M12 3.214A3.027 3.027 0 009.214 0 3.027 3.027 0 006.43 3.214 3.183 3.183 0 008.427 6.29a.215.215 0 01.144.203v4.865a.643.643 0 001.286 0V6.492a.215.215 0 01.145-.203A3.183 3.183 0 0012 3.214zM4.929 0a.643.643 0 00-.643.643v2.143a1.485 1.485 0 01-.5 1.114.213.213 0 01-.23.036.216.216 0 01-.127-.199V.643a.643.643 0 00-1.286 0v3.094a.216.216 0 01-.127.196.213.213 0 01-.23-.036 1.485 1.485 0 01-.5-1.111V.643A.643.643 0 000 .643v2.143a2.785 2.785 0 001.99 2.662.215.215 0 01.153.21v5.7a.643.643 0 001.286 0v-5.7a.215.215 0 01.152-.207 2.785 2.785 0 001.99-2.665V.643A.643.643 0 004.93 0z',
      fill: 'currentColor',
    })
  );
}
